import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Events } from '../../services/events.service';


@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit {

  NotificationUnreadCount;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private events:Events,
  ) { }

  ngOnInit() {
    this.NotificationUnreadCount = JSON.parse(localStorage.getItem('NotificationUnreadCount'));
    this.events.subscribe('updateNotificationBadge', () => {
      this.NotificationUnreadCount = JSON.parse(localStorage.getItem('NotificationUnreadCount'));
    });
  }

  ngOnDestroy() {
    // this.events.unsubscribe('updateNotificationBadge');
  }

  navigate() {
    this.router.navigate(['/notifications'])
  }
}
